<script lang="ts" setup>
// eslint-disable-next-line
import { isTranslated } from '@/models/translation.model';
import { computed } from 'vue';

const props = defineProps({
  item: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const tooltip = computed<string>(
  () =>
    isTranslated(props.item)
      ? 'Item is all translated'
      : `Item is missing one or more translations`, //${notTranslatedKeys(props.item).join(',')}
);
const icon = computed<string>(() =>
  isTranslated(props.item) ? 'mdi-progress-check' : 'mdi-progress-close',
);
const color = computed<string>(() =>
  isTranslated(props.item) ? 'green' : 'red',
);
</script>

<template>
  <v-tooltip :text="tooltip">
    <template v-slot:activator="{ props }">
      <v-icon v-bind="props" :icon="icon" :color="color"></v-icon>
    </template>
  </v-tooltip>
</template>
